<section class="nopad">

  <div class="mainHeader">
      <div class="LogoContainer">
          <img src="assets/images/AICTELogo.png" alt="Logo" class="logoImg">
          <img src="assets/images/SLALogo.png" alt="Logo" class="logoImg">
          <img src="assets/images/Parakhlogo.png" alt="Logo" class="logoImg" style="height: 47px;">
      </div>
      <div class="logoutBtnContainer">
          <button class="nav-item m-2 logoutButton" *ngIf="loggedIn" mat-raised-button
          (click)="logout($event)">Logout</button>
      </div>
  </div>

  <div class="container nopad grievancesMainContainer">
    <div class="col-12 col-md-12 col-sm-12 col-xs-12 nopad HeaderContainer">
      <div class="col-1 col-md-1 col-sm-2 col-xs-2 nopad floatLeft">
        <button mat-raised-button color="primary" style="margin-top: 15px;" (click)="back()"><mat-icon>arrow_left</mat-icon> Back</button>
      </div>
      <div class="col-9 col-md-9 col-sm-6 col-xs-6 nopad floatLeft sectionHeader">
        <h4 class="sectionHeading text-shadow">Recent Grievances</h4>
      </div>
      <div class="col-2 col-md-2 col-sm-4 col-xs-4 nopad floatLeft text-right">
        <button mat-raised-button color="primary" style="margin-top: 15px;" (click)="addGrievancePage()"><mat-icon>add</mat-icon> Add Grievance</button>
      </div>
    </div>
    <div class="container nopad">
        <div class="col-12 col-lg-12 col-md-12 col-sm-12 nopad grievancesContainer">
              <div class="grievancesItem mat-elevation-z8" *ngFor="let grievance of recentGrievances">
                  <div class="grievancesHeader">
                    <h5 class="grievancesSubject">{{grievance?.subject}}</h5>
                  </div>
                  <div class="grievancesBody">
                    <label class="grievancesID"><span class="grievancesLabelHeading">ID: </span>{{grievance?.grievance_id}}</label>
                    <label class="grievancesDate"><span class="grievancesLabelHeading">Created Date: </span>{{grievance?.created_at | date: 'dd/MM/yyyy'}}</label>
                    <label class="grievancesNature">{{grievance?.nature}}</label>
                  </div>
                  <label class="grievancesMsgHeading">Message: </label>
                  <div class="messageMainContainer">
                      <div class="messageContainer">
                          <p class="grievancesMsgText">{{grievance?.body}}</p>
                      </div>
                      <div class="attachmentContainer" style="margin-left: 10px;" *ngIf="grievance?.attachment">
                        <!-- <div *ngIf="(grievance.attachment.substring(grievance.attachment.lastIndexOf('.') + 1) === ('pdf')); else imageBlock"> -->
                            <a style="font-size: x-small;" href="{{baseUrl}}/Grievances/{{grievance?.attachment}}" class="btn btn-primary" target="_blank" >
                                View Attachment
                            </a>
                        <!-- </div>
                        <ng-template #imageBlock> -->
                            <!-- <img style="border-radius: 4px;" height="110px" (click)="viewImg(grievance?.attachment)" [src]="baseUrl + '/Grievances/' + grievance?.attachment" alt="Grievance_image"> -->
                            <!-- <a style="font-size: x-small; margin: 5px; color: white;" (click)="viewImg(grievance?.attachment)" class="btn btn-primary" >
                                View Attachment
                            </a>
                        </ng-template> -->
                          <!-- <img style="border-radius: 4px;" height="110px" (click)="viewImg(grievance?.attachment)" [src]="baseUrl + '/Grievances/' + grievance?.attachment" alt="Grievance_image"> -->
                      </div>
                      <!-- <div class="attachmentContainer" *ngIf="grievance?.reply_attachment">
                          <img style="border-radius: 4px;" height="110px" (click)="viewReplyImg(grievance?.reply_attachment)" [src]="baseUrl + '/Grievances_reply/' + grievance?.reply_attachment" alt="Grievance_Reply_image">
                      </div> -->
                  </div>
                  <div class="attachmentContainer" style="margin-left: 10px; float: right; margin-top: 5px;" *ngIf="grievance?.status=='Closed'">
                    <button class="btn viewButton" style="width: 75px;" (click)="viewGrievanceReply(grievance)" >
                        View Reply
                    </button>
                  </div>
                  <div class="stepContainer">
                    <div class="step done"  data-desc="Ticket Raised"><span>1</span><i class="fa fa-check" aria-hidden="true"></i></div>
                    <div class="step" [ngClass]="{'active': grievance?.status_id == 1,'done': grievance?.status_id == 2}" data-desc="In Progress"><span>2</span><i class="fa fa-check" aria-hidden="true"></i></div>
                    <div class="step" [ngClass]="{'done': grievance?.status_id == 2}" data-desc="Ticket Resolved"><span>3</span><i class="fa fa-check" aria-hidden="true"></i></div>
                  </div>

                  <!-- <div class="grievancesFooter">
                    <button class="btn viewBtn" (click)="viewGrievanceReply(grievance)">View</button>
                  </div> -->
              </div>
        </div>
    </div>
  </div>
</section>




<section class="FirstScroll_Section">
      <div class="contact3">
          <div class="row no-gutters">
            <div class="container">
              <div class="row">
                <div class="col-12 col-md-12 col-sm-12 col-xs-12 nopad HeaderContainer">
                  <div class="col-1 col-md-1 col-sm-2 col-xs-2 nopad floatLeft">
                  </div>
                  <div class="col-9 col-md-9 col-sm-6 col-xs-6 nopad floatLeft sectionHeader">
                    <h4 class="sectionHeading text-shadow">Resolved Grievances</h4>
                  </div>
                  <div class="col-2 col-md-2 col-sm-4 col-xs-4 nopad floatLeft text-right">
                  </div>
                </div>
            
                <!-- <div class="col-1 col-md-1"></div> -->
                <!-- <div class="col-1 col-md-1 col-sm-3 col-xs-3">
                    <button mat-raised-button color="primary" style="margin-top: 15px;" (click)="back()"><mat-icon>arrow_left</mat-icon> Back</button>
                </div> -->
                <div class="col-9 col-md-9 col-sm-6 col-xs-6 nopad">
                    <mat-form-field appearance="outline" class="col-12 nopad">
                        <mat-label>Search</mat-label>
                        <input matInput (keyup)="applyFilter()" [(ngModel)]="searchText" placeholder="Search..." #input>
                        <mat-icon matSuffix>search</mat-icon>
                    </mat-form-field>
                </div>
                <!-- <div class="col-2 col-md-2 col-sm-6 col-xs-6">
                    <button mat-raised-button color="primary" style="margin-top: 15px;" (click)="addGrievancePage()"><mat-icon>add</mat-icon> Add Grievance</button>
                </div> -->

                <div class="tabContentContainer col-12">
                    <mat-card class="mat-elevation-z8">
                    <mat-table #matTable [dataSource]="dataSource" class="dataTable" matSort>

                        <ng-container matColumnDef="id">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Id </mat-header-cell>
                            <mat-cell *matCellDef="let element;let i=index;"> {{paginator.pageIndex == 0 ? i + 1 : 1 + i + paginator.pageIndex * paginator.pageSize}} </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="grievance_id">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Grievance ID </mat-header-cell>
                            <mat-cell *matCellDef="let element;let i=index;"> {{element?.grievance_id}}</mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="nature">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Nature </mat-header-cell>
                            <mat-cell *matCellDef="let element;let i=index;"> {{element?.nature}} </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="subject">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Subject </mat-header-cell>
                            <mat-cell *matCellDef="let element;let i=index;"> {{element?.subject}} </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="committed_on">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Created On </mat-header-cell>
                            <mat-cell *matCellDef="let element;let i=index;"> {{element?.created_at | date: 'dd/MM/yyyy'}} </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="status">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Status </mat-header-cell>
                            <mat-cell *matCellDef="let element;let i=index;"> {{element?.status}} </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="view">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> View </mat-header-cell>
                            <mat-cell *matCellDef="let element">
                                <button class="btn viewButton" (click)="viewGrievanceReply(element)">View</button>
                            </mat-cell>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="7">No data matching the filter "{{input.value}}"</td>
                        </tr>

                    </mat-table>

                    <mat-paginator pageSize='10' [pageSizeOptions]="getPageSizes()"></mat-paginator>
                </mat-card>
            </div>

                <!-- Footer -->
                <div class="col-lg-12">
                  <div class="card mt-4 border-0 mb-4">
                    <div class="row">
                      <div class="col-lg-4 col-md-4 nopad">
                        <div class="card-body d-flex align-items-center c-detail pl-0">
                          <div class="mr-3 align-self-center">
                            <img src="./assets/images/ContactUs_Icons/icon1.png">
                          </div>
                          <div class="">
                            <h6 class="contactHeading font-weight-medium">Address</h6>
                            <p class="">Nelson Mandela Marg,
                              <br> Vasant Kunj, New Delhi-110070</p>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-4 nopad">
                        <div class="card-body d-flex align-items-center c-detail">
                          <div class="mr-3 align-self-center">
                            <img src="./assets/images/ContactUs_Icons/icon2.png">
                          </div>
                          <div class="">
                            <h6 class="contactHeading font-weight-medium">Phone</h6>
                            <p class="">011-29581527<br><br></p>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-4 nopad">
                        <div class="card-body d-flex align-items-center c-detail">
                          <div class="mr-3 align-self-center">
                            <img src="./assets/images/ContactUs_Icons/icon3.png">
                          </div>
                          <div class="">
                            <h6 class="contactHeading font-weight-medium">Email</h6>
                            <p class="">
                              <!-- slaproject@aicte-india.org<br><br> -->
                              parakh@aicte-india.org<br><br>
                              <!-- parakh@aicte-india.org<br><br> -->
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

</section>

  <div class="clearfix"></div>
